import { Link } from "react-router-dom";

/**
 * Teaser du manifeste pour la page d'accueil — version claire et sobre,
 * alignée sur la nouvelle direction graphique du Manifeste (plus de grand
 * aplat sombre, mise en valeur par la typographie et l'espace).
 */
export default function ManifestoTeaser() {
    return (
        <section
            data-testid="manifesto-teaser-section"
            className="py-24 md:py-32 border-t border-[#E0E1DD] bg-[#F4F5F7]"
        >
            <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-20">
                <div className="reveal flex items-center gap-4 mb-10">
                    <span
                        aria-hidden="true"
                        className="inline-block h-px w-9 bg-[#0D1B2A]/40"
                    />
                    <span className="eyebrow">Manifeste</span>
                </div>

                <h2 className="reveal h2 text-3xl md:text-5xl lg:text-[4.25rem] leading-[1.05] text-[#0D1B2A] max-w-5xl">
                    L'accessibilité cognitive{" "}
                    <span className="italic text-[#415A77]">
                        ne devrait pas être un privilège
                    </span>
                    .
                </h2>

                <div className="reveal delay-1 mt-14 md:mt-20 grid grid-cols-1 md:grid-cols-2 gap-10 md:gap-16">
                    <blockquote className="border-l border-[#0D1B2A] pl-6 md:pl-8">
                        <span className="editorial-num text-sm text-[#0D1B2A]">
                            01
                        </span>
                        <p className="mt-3 font-serif text-xl md:text-2xl leading-snug text-[#0D1B2A]">
                            L'intelligence artificielle est aussi{" "}
                            <span className="italic text-[#415A77]">
                                un outil d'accessibilité cognitive
                            </span>
                            .
                        </p>
                    </blockquote>
                    <blockquote className="border-l border-[#0D1B2A] pl-6 md:pl-8">
                        <span className="editorial-num text-sm text-[#0D1B2A]">
                            02
                        </span>
                        <p className="mt-3 font-serif text-xl md:text-2xl leading-snug text-[#0D1B2A]">
                            L'équité suppose parfois{" "}
                            <span className="italic text-[#415A77]">
                                des outils différents
                            </span>
                            .
                        </p>
                    </blockquote>
                </div>

                <div className="mt-16">
                    <Link
                        to="/manifeste"
                        data-testid="manifesto-teaser-cta"
                        className="btn-primary rounded-full inline-block px-7 py-3.5 text-sm tracking-[0.15em] uppercase"
                    >
                        Lire le manifeste complet
                    </Link>
                </div>
            </div>
        </section>
    );
}
